import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function PullQuote() {
  return <section className="w-full px-4 py-12 max-w-3xl mx-auto" data-id="element-160">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative text-center" data-id="element-161">
        <Quote className="w-16 h-16 md:w-20 md:h-20 text-brown/20 mx-auto mb-6 transform -scale-x-100" data-id="element-162" />
        <p className="font-serif text-2xl md:text-3xl text-gray-700 italic leading-relaxed" data-id="element-163">
          Wenn man verzweifelt ist, greift man nach jedem Strohhalm.
        </p>
      </motion.div>
    </section>;
}